
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const ScarringStretchMarks = () => {
  const treatments = [
    {
      name: "RF Microneedling",
      href: "/treatments/rf-microneedling",
      description: "Deep collagen remodeling for scar improvement",
      price: "$649",
      memberPrice: "$499"
    },
    {
      name: "PRF Treatment",
      href: "/treatments/prf",
      description: "Natural regenerative healing using your platelets",
      price: "$449",
      memberPrice: "$349"
    },
    {
      name: "Laser Resurfacing",
      href: "/treatments/laser-resurfacing",
      description: "Precise laser treatment for texture improvement",
      price: "$550",
      memberPrice: "$399"
    },
    {
      name: "Skin Boosters",
      href: "/treatments/skin-boosters",
      description: "Deep hydration to improve skin elasticity",
      price: "$399",
      memberPrice: "$299"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Scarring & Stretch Marks"
      subtitle="Your Skin's New Story Starts Here"
      description="We use collagen remodeling techniques to reduce the appearance of scars and stretch marks without surgery. Best for acne scars, surgical scars, stretch marks, and textural irregularities."
      treatments={treatments}
      beforeAfterText="Improvement visible after 3-6 sessions. Best results with combination treatments."
    />
  );
};

export default ScarringStretchMarks;
